import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import GroupHead from '@src/components/AdvertisingCampaign/Form/GroupHead'
import InputGroup from '@src/components/AdvertisingCampaign/Form/InputGroup'
import Footer from '@src/components/AdvertisingCampaign/Form/Footer'
import InputLabel from '@iui-kit/components/InputLabel'
import PhoneInput from '@iui-kit/components/PhoneInput'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import { Formik } from '@src/types/BriefSearch/formikProps'

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const StepSix: React.FC<HOCProps> = props => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched, setFieldValue },
    intl: { formatMessage }
  } = props

  return (
    <Step title="Brief.search.step.six.title">
      <GroupHead title="Brief.search.step.six.head.title" />
      <InputGroup indent="l">
        <InputLabel
          size="l"
          name={FIELD_NAMES.NAME}
          label="Brief.search.field.firstName.label"
          value={values[FIELD_NAMES.NAME]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.NAME] || !touched[FIELD_NAMES.NAME]}
          placeholder={formatMessage({ id: 'Brief.search.field.firstName.placeholder' })}
        />
        <InputLabel
          size="l"
          name={FIELD_NAMES.EMAIL}
          label="Brief.search.field.email.label"
          value={values[FIELD_NAMES.EMAIL]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.EMAIL] || !touched[FIELD_NAMES.EMAIL]}
          placeholder={formatMessage({ id: 'Brief.search.field.email.placeholder' })}
        />
        <PhoneInput
          size="l"
          name={FIELD_NAMES.PHONE}
          label="Brief.search.field.phone.label"
          value={values[FIELD_NAMES.PHONE]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.PHONE] || !touched[FIELD_NAMES.PHONE]}
          setFieldValue={setFieldValue}
          placeholder={formatMessage({ id: 'Brief.search.field.phone.placeholder' })}
        />
        <InputLabel
          size="l"
          name={FIELD_NAMES.COMPANY_NAME}
          label="Brief.search.field.companyName.label"
          value={values[FIELD_NAMES.COMPANY_NAME]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.COMPANY_NAME] || !touched[FIELD_NAMES.COMPANY_NAME]}
          placeholder={formatMessage({ id: 'Brief.search.field.companyName.placeholder' })}
        />
        <InputLabel
          size="l"
          name={FIELD_NAMES.SITE_URL}
          label="Brief.search.field.siteUrl.label"
          value={values[FIELD_NAMES.SITE_URL]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.SITE_URL] || !touched[FIELD_NAMES.SITE_URL]}
          placeholder={formatMessage({ id: 'Brief.search.field.siteUrl.placeholder' })}
        />
      </InputGroup>
      <Footer />
    </Step>
  )
}

export default compose<React.FC>(connect, injectIntl)(StepSix)
